import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { Subscription } from 'rxjs';
@Component({
    selector: 'autologin',
    template: ''
})
export class AutoLoginComponent implements OnDestroy {
    private subs: Subscription;

    constructor(public oauthService: OAuthService, private router: Router) {
        if (this.oauthService.discoveryDocumentLoaded) {
            this.login();
        } else {
            this.subs = this.oauthService.events.subscribe(event => {
                if (event instanceof OAuthSuccessEvent) {
                    if (event.type === 'discovery_document_loaded')
                        this.login();
                }
            });
        }
    }

    async login() {
        this.oauthService.initLoginFlow();
        this.oauthService.setupAutomaticSilentRefresh();
        const connected = this.oauthService.hasValidAccessToken() || await this.oauthService.tryLogin();
        if (connected) {
            this.router.navigate(['/signin-oidc'])
        } else {
            this.router.navigate(['/'])
        }
    }

    ngOnDestroy(): void {
        if (this.subs)
        this.subs.unsubscribe();
    }
}
